import Failure from '../../../core/Failure';
import HttpClient from '../../../core/HttpClient';

interface ConfirmAccountPayload {
  userUid: string;
  companyId: string;
}

interface ConfirmAccountResponse {
  success: boolean;
  error?: string;
}

/**
 * Confirm a leedflow account that was pre-created as incomplete.
 * Removes the `incomplete` flag from user & company documents
 * and triggers the welcome email.
 */
async function confirmAccount(
  payload: ConfirmAccountPayload
): Promise<ConfirmAccountResponse> {
  try {
    const response = await HttpClient.post(
      '/leedflow/account/confirm',
      payload,
      '',
      false
    );

    return response;
  } catch (e) {
    console.error('confirmAccount error:', e);
    if (e instanceof TypeError && e.message === 'Failed to fetch') {
      throw new ConfirmAccountFailure('Le serveur ne répond pas');
    } else if (e instanceof Error) {
      throw new ConfirmAccountFailure(e.message);
    }
    return Promise.reject(e);
  }
}

export class ConfirmAccountFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}

export default confirmAccount;

